<template>
  <!-- Got submenu / got children -->
  <div v-if="menu.children">
    <li @click="subMenu = !subMenu" tag="li" :class="activeSider(menu.path)">
      <a class="nav-link">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <i v-if="true" class="nc-icon" :class="menu.icon"></i>
            <p class="text-capitalize">{{ $t(`label.${menu.name}`) }}</p>
          </div>
          <i
            :class="`fa-solid fa-angle-${subMenu ? 'down' : 'right'} m-0`"
            style="font-size: 17px"
          ></i>
        </div>
      </a>
    </li>
    <ul v-if="subMenu" class="animate__animated animate__fadeInLeft">
      <li
        v-for="(i, index) in menu.children"
        :key="index"
        :class="activeSubSider(i.path)"
      >
        <router-link :to="{ name: i.routeName }" class="active nav-link">
          <div class="d-flex align-items-center">
            <i v-if="true" class="nc-icon" :class="i.icon"></i>
            <p class="text-capitalize">{{ $t(`label.${i.name}`) }}</p>
          </div>
        </router-link>
      </li>
    </ul>
  </div>
  <!-- Got menu -->
  <li v-else tag="li" :class="activeSider(menu.path)">
    <router-link :to="{ name: menu.routeName }" class="active nav-link">
      <div class="d-flex align-items-center">
        <i v-if="true" class="nc-icon" :class="menu.icon"></i>
        <p class="text-capitalize">{{ $t(`label.${menu.name}`) }}</p>
      </div>
    </router-link>
  </li>
</template>
<script>
import { ROUTE_NAME } from "@/core/constants";

export default {
  inheritAttrs: false,
  inject: {
    autoClose: {
      default: true,
    },
  },
  props: {
    tag: {
      type: String,
      default: "router-link",
    },
    menu: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    routeName: ROUTE_NAME,
    subMenu: false,
    active: null,
  }),
  methods: {
    activeSider(match) {
      if (this.$route["path"].indexOf(match) !== -1) return "active";
    },
    activeSubSider(match) {
      if (this.$route["path"].indexOf(match) !== -1) return "active-sub";
    },
  },
};
</script>
<style></style>
